module.exports = __webpack_public_path__ + "img/vue.b3fef37b.svg";